import { useQuery } from 'react-query';
import { BuildFoundryService } from '../api/BuildFoundryService';

interface UseItemDetailsOptions {
  itemId: string;
  enabled?: boolean;
}

export const useItemDetails = ({ itemId, enabled = true }: UseItemDetailsOptions) => {
  // Fetch comprehensive item data including price history and production info
  const itemDetailsQuery = useQuery(
    ['foundry-item-details', itemId],
    () => BuildFoundryService.getFoundryItemById(itemId),
    {
      enabled: enabled && !!itemId,
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
    }
  );

  // Extract the item data and price information
  const itemData = itemDetailsQuery.data?.data;
  const priceHistory = itemData?.priceHistoryList || [];
  const priceSummary = itemData?.priceSummary;

  return {
    itemDetails: itemData,
    priceHistory,
    priceSummary,
    isLoading: itemDetailsQuery.isLoading,
    isError: itemDetailsQuery.isError,
    error: itemDetailsQuery.error,
    refetch: itemDetailsQuery.refetch,
  };
};
